(function($, undefined) {
	'use strict';
    var openEventDetailsIframeBtn;

    var openEventDetailsIframe = function(e) {
        var t = $(this);
        var src = t.attr('data-iframe');
        var iframe = t.find('.event-details-iframe-popup-inner');
        var popup = t.closest('.popup-outer-ctn').find('.popup');
        var target = $(e.target);

        if (!target.closest('.popup-inner-close').length) {
            if (iframe.attr('src') === undefined) {
                iframe.attr('src', src);

                setTimeout(function() {
                    popup.addClass('open processing-loader is-processing');
                    $('.overlay', 'body').addClass('active');
                }, 300);
            } else {
                popup.addClass('open');
                $('.overlay', 'body').addClass('active');
            }
        }
    };

	var init = function() {
        openEventDetailsIframeBtn = $('.open-event-details-popup');
        openEventDetailsIframeBtn.click(openEventDetailsIframe);
	};
	
	$(window).on('load',function(){
		init();
	});
	
})(jQuery);